import { Injectable } from '@angular/core';
import { TransitionService, Transition } from '@uirouter/core';
import { ConfirmationService } from 'primeng/api';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class UnsavedFormCheckService {
    constructor (
        private confirmationService: ConfirmationService,
        private readonly translocoService: TranslocoService,
    ) {}
    private deregisterFn: (() => void) | null = null;

    private showConfirmDialogBase (onAccept: () => void, onReject: () => void): void {
        this.confirmationService.confirm({
            header: this.translocoService.translate('unsavedFormCheck.dialog.header'),
            message: this.translocoService.translate('unsavedFormCheck.dialog.message'),
            closable: true,
            closeOnEscape: true,
            dismissableMask: true,
            rejectButtonProps: {
                label: this.translocoService.translate('unsavedFormCheck.dialog.rejectButtonLabel'),
                variant: 'text',
            },
            acceptButtonProps: {
                label: this.translocoService.translate('unsavedFormCheck.dialog.acceptButtonLabel'),
                severity: 'primary',
            },
            accept: onAccept,
            reject: onReject,
        });
    }

    private showConfirmDialog (onAccept?: () => void): Promise<boolean> {
        return new Promise((resolve) => {
            this.showConfirmDialogBase(
                () => {
                    if (onAccept) {
                        onAccept();
                    }
                    resolve(true);
                },
                () => resolve(false),
            );
        });
    }

    registerGuard (
        transitionService: TransitionService,
        shouldConfirm: () => boolean,
        onAccept?: () => void,
    ): () => void {
        this.deregisterFn = transitionService.onBefore({}, (transition: Transition) => {
            if (shouldConfirm()) {
                // return this.showConfirmDialogWithTransition(transition, onAccept);
                return this.showConfirmDialog(onAccept);
            }
            return true;
        }) as () => void;
        return this.deregisterFn;
    }

    unregisterGuard () {
        if (this.deregisterFn) {
            this.deregisterFn();
            this.deregisterFn = null;
        }
    }

    confirmNavigation (shouldConfirm: boolean, onAccept?: () => void): Promise<boolean> {
        if (!shouldConfirm) {
            if (onAccept) {
                onAccept();
            }
            return Promise.resolve(true);
        }
        return this.showConfirmDialog(onAccept);
    }
}
